import { render, staticRenderFns } from "./EFormGestao.vue?vue&type=template&id=286651c6&scoped=true"
import script from "./EFormGestao.vue?vue&type=script&lang=js"
export * from "./EFormGestao.vue?vue&type=script&lang=js"
import style0 from "./EFormGestao.vue?vue&type=style&index=0&id=286651c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286651c6",
  null
  
)

export default component.exports